export default __webpack_public_path__ + "media/metronic/_theme/media/bg/350-c3590bfc7cc20f577e9708d797e2891d.jpg";